import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IResponse } from 'src/app/pages/base/interfaces';
import { TransaccionModel } from '../transaccion.model';
import { RendicionService } from 'src/app/services/tesoreria/rendicion.service';


export class Rendicion extends TransaccionModel {

    public static RECORD_NAME = 'rendiciones';
    public static CODIGO_REGISTRO = 'rendicion';
    public static CODIGO_MODULO = 'tesoreria';
    public static NOMBRE_SINGULAR = 'Rendicion';
    public static NOMBRE_PLURAL = 'Rendiciones';

    private _idEmpresa: number;
    private _nombreEmpresa: string;
    private _idSucursal: number;
    private _nombreSucursal: string;
    private _idConceptoPrincipal: number;
    private _codigoConceptoPrincipal: string;
    private _nombreConceptoPrincipal: string;
    private _codigoConceptoSecundario: string;
    private _nombreConceptoSecundario: string;
    private _comentario: string;
    private _monto: number;
    private _referencia: string;

    constructor() {
        super();
        const currentUser = this.seguridad.getCurrentUser();
        this._idEmpresa = currentUser?.id_empresa;
        this._nombreEmpresa = currentUser?.nombre_empresa;
        this._idSucursal = currentUser?.id_sucursal;
        this._nombreSucursal = currentUser?.nombre_sucursal;
        this._monto = 0;
    }

    public set idEmpresa( idEmpresa: number ) { this._idEmpresa = idEmpresa };
    public get idEmpresa(): number { return this._idEmpresa };

    public set nombreEmpresa( nombreEmpresa: string ) { this._nombreSucursal = nombreEmpresa };
    public get nombreEmpresa(): string { return this._nombreEmpresa };

    public set idSucursal( idSucursal: number ) { this._idSucursal = idSucursal };
    public get idSucursal(): number { return this._idSucursal };

    public set nombreSucursal( nombreSucursal: string ) { this._nombreSucursal = nombreSucursal };
    public get nombreSucursal(): string { return this._nombreSucursal };

    public set idConceptoPrincipal( idConceptoPrincipal: number ) { this._idConceptoPrincipal = idConceptoPrincipal };
    public get idConceptoPrincipal(): number { return this._idConceptoPrincipal };

    public set codigoConceptoPrincipal( codigoConceptoPrincipal: string ) { this._codigoConceptoPrincipal = codigoConceptoPrincipal };
    public get codigoConceptoPrincipal(): string { return this._codigoConceptoPrincipal }

    public set nombreConceptoPrincipal( nombreConceptoPrincipal: string ) { this._nombreConceptoPrincipal = nombreConceptoPrincipal };
    public get nombreConceptoPrincipal(): string { return this._nombreConceptoPrincipal }

    public set codigoConceptoSecundario( codigoConceptoSecundario: string ) { this._codigoConceptoSecundario = codigoConceptoSecundario };
    public get codigoConceptoSecundario(): string { return this._codigoConceptoSecundario };

    public set nombreConceptoSecundario( nombreConceptoSecundario: string ) { this._nombreConceptoSecundario = nombreConceptoSecundario };
    public get nombreConceptoSecundario(): string { return this._nombreConceptoSecundario }

    public set comentario( comentario: string ) { this._comentario = comentario };
    public get comentario(): string { return this._comentario }

    public set monto( monto: number ) { this._monto = monto };
    public get monto(): number { return this._monto };

    public set referencia( referencia: string ) { this._referencia = referencia };
    public get referencia(): string { return this._referencia };

    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'id_concepto_principal', label: 'id', type: 'id' },
            { field: 'codigo_concepto_principal', label: 'Codigo', type: 'text' },
            { field: 'nombre_concepto_principal', label: 'Nombre', type: 'text' },
        ]
    }

    async cargarDatos( objeto: Record<string, any> ) {
        this._idEmpresa = objeto?.id_empresa;
        this._nombreEmpresa = objeto?.nombre_empresa;
        this._idSucursal = objeto?.id_sucursal;
        this._nombreSucursal = objeto?.nombre_sucursal;
        this._idConceptoPrincipal = objeto?.id_concepto_principal;
        this._codigoConceptoPrincipal = objeto?.codigo_concepto_principal;
        this._nombreConceptoPrincipal = objeto?.nombre_concepto_principal;
        this._codigoConceptoSecundario = objeto?.codigo_concepto_secundario;
        this._nombreConceptoSecundario = objeto?.nombre_concepto_secundario;
        this._comentario = objeto?.comentario;
        this._monto = objeto?.monto;
        this._referencia = objeto?.referencia;
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        await this.cargarDatos( objeto );        
    }

    async actualizarDatos( objeto: Record< string, any> ) {
        await super.actualizarDatos( objeto );
        await this.cargarDatos( objeto );
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("id_empresa", new FormControl(this._idEmpresa, Validators.required));
        fg.addControl("nombre_empresa", new FormControl(this._nombreEmpresa));
        fg.addControl("id_sucursal", new FormControl(this._idSucursal, Validators.required));
        fg.addControl("nombre_sucursal", new FormControl(this._nombreSucursal, Validators.required));
        fg.addControl("id_concepto_principal", new FormControl(this._idConceptoPrincipal, Validators.required));
        fg.addControl("codigo_concepto_principal", new FormControl(this._codigoConceptoPrincipal, Validators.required));
        fg.addControl("nombre_concepto_principal", new FormControl(this._nombreConceptoPrincipal, Validators.required));
        fg.addControl("codigo_concepto_secundario", new FormControl(this._codigoConceptoSecundario));
        fg.addControl("nombre_concepto_secundario", new FormControl(this._nombreConceptoSecundario));
        fg.addControl("comentario", new FormControl(this._comentario, Validators.required));
        fg.addControl("referencia", new FormControl(this._referencia));
        fg.addControl("monto", new FormControl(this._monto));
        
        return fg;
    }

    async guardar( service: RendicionService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    async actualizar( service: RendicionService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    async eliminar( service: RendicionService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}
